import { formatOneGraphData } from '../../navigationMenuParser';
import { geoCountryCode, locales } from '../../types';
import { englishContentIntl, englishContentUS, enLegalNav } from './english';
import { koreanContentIntl, koreanContentUS, koLegalNav } from './korean';
import { spanishContentIntl, spanishContentUS, esLegalNav } from './spanish';
import { turkishContentIntl, turkishContentUS, trLegalNav } from './turkish';
export function getSignedOutFooterNavLinks(locale, countryCode) {
  var signedOutFooterNavLinks = {};

  switch (locale) {
    case locales['es-419']:
    case locales.es:
      signedOutFooterNavLinks = countryCode === geoCountryCode.US ? spanishContentUS : spanishContentIntl;
      break;

    case locales.ko:
      signedOutFooterNavLinks = countryCode === geoCountryCode.US ? koreanContentUS : koreanContentIntl;
      break;

    case locales.tr:
      signedOutFooterNavLinks = countryCode === geoCountryCode.US ? turkishContentUS : turkishContentIntl;
      break;

    default:
      signedOutFooterNavLinks = countryCode === geoCountryCode.US ? englishContentUS : englishContentIntl;
  }

  return formatOneGraphData(signedOutFooterNavLinks);
}
export function getLegalNavLinks(locale) {
  var legalNavLinks = {};

  switch (locale) {
    case locales.es:
    case locales['es-419']:
      legalNavLinks = esLegalNav;
      break;

    case locales.ko:
      legalNavLinks = koLegalNav;
      break;

    case locales.tr:
      legalNavLinks = trLegalNav;
      break;

    default:
      legalNavLinks = enLegalNav;
  }

  return formatOneGraphData(legalNavLinks);
}